import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Paraty**
 *
 * @exports bs_15
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let priceUpdate;
  let refreshPrice;

  /**
     * @memberOf module:bs_15
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {
    const isLogged = document.querySelector('#login_container .user_info_wrapper')?.style.display === 'block'
    || !!document.querySelector('.username_text')?.textContent
    || !!document.querySelector('.logged_user')
    || !!document.querySelector('.logged');

    return isLogged;
  };

  /**
     * @memberOf module:bs_15
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      var aux;

      thn.domReady().then(function () {

        aux = (ctx.getHtmlLang() || 'es').substr(0, 2);
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        reject('no_language');
      });
    });
  };

  /**
     * @memberOf module:bs_15
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const roomDiv = document.getElementById('rooms_b1_wrapper');
    if (roomDiv && !thn.mutationFunction) {
      thn.mutationFunction = function (mutations) {
        var checked = false;
        Array.from(mutations).forEach(function (mutation) {
          if (mutation.target.classList && !checked && (
            mutation.target.classList.contains('tPrecioTachado')
            || mutation.target.classList.contains('precioGeneral'))) {
            // Just check once
            checked = true;
            // try to refresh the PW data, then hide only if PW data is not set
            if (ctx.widget.refresh() && !ctx.widget.isSet()) {
              ctx.widget.hide();
            }
          }
        });
      };

      const updateFunction = thn.debounce(thn.mutationFunction, 600);

      thn.observeDom(roomDiv, updateFunction, {
        childList: true,
        subtree: true,
        characterData: false,
      });

      // On page unload, stop observing
      thn.pageUnload(function () {
        thn.stopObserveDom(roomDiv, updateFunction);
        delete thn.mutationFunction;
      });
    }

    const currencyEl = document.querySelector('.currency_selector');
    if (currencyEl && !priceUpdate) {
      priceUpdate = thn.debounce(function () {
        thn.widgets.price.update();
      }, 500);

      thn.observeDom(currencyEl, priceUpdate, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      thn.shutdown(() => {
        priceUpdate.cancel();
        thn.stopObserveDom(currencyEl, priceUpdate);
        priceUpdate = null;
      });
    }
    // Observe the room list for changes
    const roomListEl = document.querySelector('.room_list');

    if (roomListEl && !thn.roomListMutationObserver) {
      thn.roomListMutationObserver = function (mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            ctx.widget.refresh();
          }
        }
      };

      const observerCallback = thn.debounce(thn.roomListMutationObserver, 500);

      thn.observeDom(roomListEl, observerCallback, {
        childList: true,
        subtree: true,
      });

      thn.pageUnload(() => {
        thn.stopObserveDom(roomListEl, observerCallback);
        delete thn.roomListMutationObserver;
      });
    }

    if (!refreshPrice) {
      refreshPrice = thn.debounce(() => { thn.widgets.price.update(); }, 500);
      thn.bus.on('dataLayer:event.add_to_cart', refreshPrice);

      thn.pageUnload(() => {
        thn.bus.detach('dataLayer:event.add_to_cart', refreshPrice);
        refreshPrice.cancel();
        refreshPrice = null;
      });
    }
  };

  /**
     * @memberOf module:bs_15
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // https://booking.guitarthotels.com/booking1?namespace=guitart-gold&startDate=19/07/2024&endDate=20/07/2024&promocode=&numRooms=1&adultsRoom1=2&childrenRoom1=0&babiesRoom1=0&agesKid1=&language=SPANISH
    // https://booking.oasishoteles.com//booking1?language=SPANISH&namespace=oasishoteles-senscancun&startDate=16%2F12%2F2025&endDate=18%2F12%2F2025&numRooms=2&adultsRoom1=2&childrenRoom1=0&babiesRoom1=0&adultsRoom2=1&childrenRoom2=1&babiesRoom2=0&agesKid1=5

    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/booking/i) && url.pathname.match(/booking1/i);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    const langMapping = {
      es: 'SPANISH',
      en: 'ENGLISH',
      fr: 'FRENCH',
      de: 'GERMAN',
      it: 'ITALIAN',
      pt: 'PORTUGUESE',
      nl: 'DUTCH',
      sv: 'SWEDISH',
    };

    if (ctx.data.language && langMapping[ctx.data.language]) {
      url.searchParams.set('language', langMapping[thn.data.language]);
    }
    url.searchParams.set('startDate', '[date_begin]');
    url.searchParams.set('endDate', '[date_end]');
    url.searchParams.set('numRooms', ctx.data.roomsDispo?.length || '1');
    let childNum = 1;
    if (ctx.data.roomsDispo && ctx.data.roomsDispo.length > 0) {
      ctx.data.roomsDispo.forEach((room, index) => {
        url.searchParams.set(`adultsRoom${index + 1}`, room.adults || '2');
        url.searchParams.set(`childrenRoom${index + 1}`, room.children || '0');
        url.searchParams.set(`babiesRoom${index + 1}`, '0');
        if (room.childrenAges && room.childrenAges.length > 0) {
          room.childrenAges.forEach((age) => {
            url.searchParams.set(`agesKid${childNum}`, age);
          });
          childNum += room.childrenAges.length;
        }
      });
    }

    ctx.newData.dateBegin = ctx.data.dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    ctx.newData.dateEnd = ctx.data.dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
    *
    * @memberOf module:bs_15
    *
    */
  const roomDetailsParseData = () => [...document.querySelectorAll('.contTipoHabitacion, .room_pack_option')].map((room) => {
    const roomName = room.querySelector('.cabeceraNombreHabitacion .tipoHabitacion, .title')?.textContent.trim();
    const roomType = getRoomType(roomName);
    const occupancy = room.attributes?.occupancy?.value?.split('-');
    const roomRates = [...room.querySelectorAll('.regimen_tr_element, .regime_item_content')].map((rate) => {
      const rateDetailEl = rate.querySelector('.precioTotalColumn .precioGeneralDiv span');
      const rateName = rate.querySelector('.regimen_name_wrapper, .regime_title')?.textContent;
      const ratePrice = thn.parseNumber(rate?.querySelector('.precioNocheColumn .precioGeneralDiv, .final_price')?.textContent);
      const isFlexibleRate = thn.data.media.name === 'mobile' ? !!rate.parentElement.querySelector('.last_day_cancellation_text') : !rateDetailEl?.className?.includes('noreembolsable');
      const breakfastMobileText = /breakfast|desayuno|colazione|café da manhã|petit-déjeuner|ontbijt|half board|media pensión|mezza pensione|demi pension|pensión completa|full board|pensione completa|pension complète/;
      const breakfastDesktopText = /alojamientoydesayuno|mediapension|pensioncompleta/;
      const breakfast = thn.data.media.name === 'mobile' ? breakfastMobileText.test(rateName.toLowerCase()) : breakfastDesktopText.test(rateDetailEl?.className);
      const nights = thn.parseNumber(document.querySelector('div.row.search-resume-wrapper .dates span')?.textContent);
      const rateData = {
        id: rate.id || '',
        name: rateName,
        totalNight: thn.data.media.name === 'mobile' ? ratePrice / nights : ratePrice,
        breakfast,
        refundable: isFlexibleRate,
      };

      return rateData;
    });

    return {
      id: room.dataset?.roomId || '',
      name: roomName,
      adults: thn.parseNumber(occupancy?.[0]) || thn.parseNumber(document.querySelector('.room_pack_option')?.dataset?.roomAvailability) || 2,
      children: thn.parseNumber(occupancy?.[1]) || 0,
      type: roomType,
      prices: roomRates,
    };
  });
  /**
     * @memberOf module:bs_15
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */

  const ONAHOTELS_UID = 1021872;
  const BLAUMAR_UID = 1031995;
  engine._shouldUseLockedPrices = function () {
    // This function contains the logic to decide
    // if we should take into account "locked prices".
    // Now It is simple, but if the condition gets complicated
    // same principle applies, you only need to change the logic on one place
    return [ONAHOTELS_UID, BLAUMAR_UID].includes(thn.data.accountUserId);
  };

  engine.priceParseData_v1 = function priceParseData_v1(ctx) {
    // *****  General Version (works on some mobile pages)  ********//
    const widgetData = {};

    const obj = window.lowerPriceObj;

    if (!document.querySelector('#datepicker1, div.booking-search-results > div > span.notranslate, .search-resume-wrapper .dates > p')) {
      return widgetData;
    }

    ctx.widget.logger.debug('--- Paraty General Version ---');

    // Dates
    let entryDate;
    let departureDate;
    let nights;

    const dateInfo = document.querySelectorAll('div.booking-search-results > div > span.notranslate');
    const dateElem = document.querySelector('.search-resume-wrapper .dates > p')?.textContent?.trim().split('(')?.[0]?.split('-');

    if (dateInfo && dateInfo.length > 1) {
      entryDate = translateDate(dateInfo[0].textContent, thn.data.language)
        || dateInfo[0].textContent.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1').trim();
      departureDate = translateDate(dateInfo[1].textContent, thn.data.language)
        || dateInfo[1].textContent.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1').trim();
    }

    if (dateElem && dateElem.length > 1) {
      entryDate = translateDate(dateElem[0].trim(), thn.data.language);
      departureDate = translateDate(dateElem[1].trim(), thn.data.language);
    } else {
      entryDate = translateDate(((document.querySelector('#datepicker1') || {}).value || ''), thn.data.language)
        || ((document.querySelector('#datepicker1') || {}).value || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1')
        || (obj && obj.checkinDate && obj.checkinDate.replace(/-/g, '/'));
      departureDate = translateDate(((document.querySelector('#datepicker2') || {}).value || ''), thn.data.language)
        || ((document.querySelector('#datepicker2') || {}).value || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1')
        || (obj && obj.checkoutDate && obj.checkoutDate.replace(/-/g, '/'));
    }

    if (entryDate && departureDate) {
      widgetData.dateBegin = thn.dateToString(entryDate);
      widgetData.dateEnd = thn.dateToString(departureDate);
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Rooms
    widgetData.rooms = thn.parseNumber(thn.dataLayerHelper.get('roomsNumber')
      || document.querySelector('#internalNumRooms')?.textContent
      || document.querySelector('select#selector_habitaciones')?.value
      || '1');

    // Guests
    let adults;
    let children;
    widgetData.adults = 0;
    widgetData.children = 0;

    const multiroomSelector = document.querySelector('.room_step_block:not(.selected)');

    if (multiroomSelector && widgetData.rooms > 1) {
      widgetData.adults = thn.parseNumber(multiroomSelector.querySelector('.room_step_occupancy_adults')?.textContent);
      widgetData.children = thn.parseNumber(multiroomSelector.querySelector('.room_step_occupancy_kids')?.textContent);
      widgetData.rooms = 1;
    } else {
      for (let i = 0; i < widgetData.rooms; i += 1) {
        if (document.querySelector('.room_adults')) {
          adults = thn.parseNumber(((document.querySelector('.room_adults')?.textContent?.match(/\d/) || [''])[`${i}`]) || '2');
          children = thn.parseNumber(((document.querySelector('.room_kids')?.textContent?.match(/\d/) || [''])[`${i}`]) || '0');
        } else {
          adults = thn.parseNumber(document.querySelector(`input#internalNum${i + 1}AdultsRooms`)?.value || '2');
          children = thn.parseNumber(document.querySelector(`input#internalNum${i + 1}KidsRooms`)?.value || '0');
        }

        widgetData.adults += adults;
        widgetData.children += children;
      }
    }

    if (thn.empty(widgetData.adults)) {
      widgetData.adults = 2;
      ctx.widget.logger.debug('--- Error when retrieving number of guests ---');
    }

    widgetData.guests = widgetData.adults + widgetData.children;

    if (widgetData.children > 0) {
      widgetData.childrenAges = Array.from({ length: widgetData.children }, () => 5);
    }

    const shouldUseLockedPrices = engine._shouldUseLockedPrices();
    const usersFilteringRooms = {
      1048733: 'pitch|parcel|terrain|mittlere|perceel', // TAIGA
      1041052: 'parcel', // Estival Camping
    };
    // Price & Currency
    let priceEls = [...document.querySelectorAll('.precio_final, .precioTotal.nopromo, .room_from_price_value, .total-price')];
    if (usersFilteringRooms[thn.data.accountUserId]) {
      const regex = new RegExp(usersFilteringRooms[thn.data.accountUserId], 'i');
      priceEls = priceEls.filter((elm) => !elm.closest('.room-element-wrapper')
        ?.querySelector('.room-name')
        ?.textContent
        ?.trim()
        ?.match(regex));
    }

    let prices;

    if (!thn.empty(priceEls)) {
      // This BE has different classes for the price Element. It offers normal prices,
      // and selective discounts depending the device we use and other target rules we do not know
      prices = priceEls.map((elm) => thn.parseNumber(elm.textContent)).filter((elm) => (typeof elm) === 'number');
    } else {
      const priceElsUnlockedSelector = multiroomSelector ? '.room_step_block:not(.selected).active .precioNocheColumn .precioGeneralDiv .currencyValue' : '.precioNocheColumn .precioGeneralDiv .currencyValue';
      const priceElsLockedSelector = '.lock_board_wrapper .currencyValue';
      priceEls = [...document.querySelectorAll(shouldUseLockedPrices ? priceElsLockedSelector : priceElsUnlockedSelector)]; // for ONA hotels we are collecting the loyalty price
      prices = priceEls.map((el) => thn.parseNumber(el.textContent)).filter((price) => price);
    }

    const currency = Array.from(document.querySelectorAll('.currency_selector_wrapper_v2 .selector .option'))
      .find((o) => {
        const t = document.querySelector('.currency_selector_wrapper_v2 .label.selected, .currency_selector_wrapper_v2 .label.default')?.textContent?.trim();
        return o.textContent?.trim() === t || o.getAttribute('data-name')?.trim() === t;
      })
      ?.getAttribute('data-shortname')
      || thn.parseCurrency(window.shortCurrency)
      || thn.parseCurrency((document.querySelector('.monedaConv.precioTotal, .monedaConv') || {})?.textContent?.split(' ')[0])
      || 'EUR';

    // Case identified on p1027330 and p1025336
    // Let's get the price wrapper and check if it has the element "total_nights"
    // If we can obtain it, it would mean that have have the total price, not the price per night
    const isPriceTotal = !!document.querySelector('.prices_options .total_nights, .precioTotal .numero_noche') || (thn.isVisible(document.querySelector('.room_from_price_label')) && !!document.querySelector('.room_from_price_label')?.textContent?.match(/total|gesamtpreis/i));

    // special price
    const isPriceSpecial = !!thn.parseUrlParameter('roomFilter') || (!thn.empty(window.calendar_data?.roomFilter) && window.calendar_data.roomFilter !== '.*');
    if (isPriceSpecial) {
      widgetData.priceSpecial = 1;
    }

    if (prices.length && nights) {
      widgetData.price = shouldUseLockedPrices || isPriceTotal ? Math.min(...prices) / nights : Math.min(...prices);
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData();
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    if (document.querySelector('.no-availability-message')) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  engine.priceParseData_v2 = function priceParseData_v2(ctx) {
    // *****  Mobile Version  *******//
    const widgetData = {};

    if (document.querySelector('#datepicker1')) {
      return widgetData;
    }

    ctx.widget.logger.debug('--- Paraty Mobile Version ---');

    // Dates
    const checkIn = window.calendar_data?.startDate.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    const checkOut = window.calendar_data?.endDate.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    const entryDateSel = document.querySelector('.entry_date');
    const departureDateSel = document.querySelector('.departure_date');
    const entryDate = entryDateSel && translateDate(entryDateSel?.textContent, thn.data.language);
    const departureDate = departureDateSel && translateDate(departureDateSel?.textContent, thn.data.language);
    let nights;

    if (checkIn && checkOut) {
      widgetData.dateBegin = checkIn;
      widgetData.dateEnd = checkOut;
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    } else if (entryDate && departureDate) {
      widgetData.dateBegin = entryDate;
      widgetData.dateEnd = departureDate;
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Rooms
    const roomDetails = window.json_datalayer ? JSON.parse(window.json_datalayer) : null;
    widgetData.rooms = thn.parseNumber(roomDetails?.roomsNumber) || thn.parseNumber((document.querySelector('.quantity') || {}).textContent || '1');

    // Guests
    const guestSelector = document.querySelector('.guest_selector')?.textContent?.split('+').map((guest) => thn.parseNumber(guest));
    const adults = thn.parseNumber(roomDetails?.adultsNumber) || guestSelector?.[0] || 2;
    const children = thn.parseNumber(roomDetails?.childrenNumber) || guestSelector?.[1] || 0;

    widgetData.adults = adults;
    widgetData.children = children;

    widgetData.guests = widgetData.adults + widgetData.children;

    const shouldUseLockedPrices = engine._shouldUseLockedPrices();
    // Price & Currency
    let lowestPrice;
    const priceElsUnlockedSelector = '.price.currencyValue';
    const priceElsLockedSelector = '.lock_board_wrapper .currencyValue';
    const priceEls = [...document.querySelectorAll(shouldUseLockedPrices ? priceElsLockedSelector : priceElsUnlockedSelector)]; // for ONA hotels we are collecting the loyalty price
    const currency = thn.parseCurrency(document.querySelector('.first_currency')?.textContent?.split(' ')[0]) || 'EUR';

    // Case identified on p1027330 and p1025336
    // Let's get the price wrapper and check if it has the element "total_nights"
    // If we can obtain it, it would mean that have have the total price, not the price per night
    const isPriceTotal = !!document.querySelector('.prices_options .total_nights, .precioTotal .numero_noche, .final_price');

    // multiple rooms case 1
    const multiRooms = Array.from(document.querySelectorAll('.room_option_block')).filter((el) => el.style.display !== 'none');
    const multiRoomsPrices = multiRooms?.length ? Array.from(multiRooms[multiRooms.length - 1]?.querySelectorAll('.room_from_price_value .currencyValue') || []).map((el) => thn.parseNumber(el.textContent)) : [];

    // multiple rooms case 2
    const multipleRoomBlocks = [...multiRooms].map((room) => room.querySelectorAll(shouldUseLockedPrices ? priceElsLockedSelector : priceElsUnlockedSelector));
    const multipleRoomPrices = [];

    if (multiRoomsPrices.length > 0) {
      // If there is only one room, we take the price from the last room
      lowestPrice = shouldUseLockedPrices || isPriceTotal ? Math.min(...multiRoomsPrices
        .map((price) => price / nights)) : Math.min(...multiRoomsPrices);
    } else if (!thn.empty(multipleRoomBlocks) && multipleRoomBlocks.length > 1) {
      for (let i = 1; i <= 2; i += 1) {
        const pricesList = [...multipleRoomBlocks[i - 1]].map((price) => (shouldUseLockedPrices || isPriceTotal ? thn.parseNumber(price?.textContent) / nights : thn.parseNumber(price?.textContent))).filter(Boolean);
        multipleRoomPrices.push(Math.min(...pricesList));
      }

      lowestPrice = multipleRoomPrices.reduce((sum, current) => sum + (typeof current === 'number' ? current : 0), 0);

    } else {
      const prices = priceEls.map((el) => thn.parseNumber(el.textContent)).filter((elm) => (typeof elm) === 'number');
      lowestPrice = shouldUseLockedPrices || isPriceTotal ? Math.min(...prices) / nights : Math.min(...prices);
    }

    // special price
    const isPriceSpecial = !!thn.parseUrlParameter('roomFilter');
    if (isPriceSpecial) {
      widgetData.priceSpecial = 1;
    }

    if (lowestPrice && nights) {
      widgetData.price = lowestPrice;
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData();
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_15
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {
    const widgetData = {};
    const dataLayer = window.dataLayer;
    const mhsCV = window.mhsCV;

    // Id
    const bookingId = thn.dataLayerHelper.get('confirmationId')
      || thn.dataLayerHelper.get('ecommerce.transaction_id')
      || window.bookingId
      || mhsCV?.reservationnumber
      || thn.objectGet(dataLayer, 'transaction')
      || thn.objectGet(dataLayer, 'booking_id')
      || document.querySelector('.location_id_wrapper')?.textContent?.split(':')[1].trim();

    widgetData.bookingId = bookingId;

    // Dates
    widgetData.dateBegin = thn.dataLayerHelper.get('startDate')?.replace(/-/g, '/')
      || document.querySelector('input#internalStartDate')?.value
      || ((thn.objectGet(dataLayer, 'checkin'))
        || thn.dataLayerHelper.get('checkinDate'))?.replace(/-/g, '/');
    widgetData.dateEnd = thn.dataLayerHelper.get('endDate')?.replace(/-/g, '/')
      || document.querySelector('input#internalEndDate')?.value
      || (thn.dataLayerHelper.get('checkoutDate')
        || thn.objectGet(dataLayer, 'checkout'))?.replace(/-/g, '/');

    widgetData.currency = thn.getCurrencyCode(mhsCV?.currency) || thn.objectGet(dataLayer, 'currency') || window.ClientAPI?.getCurrencyCode();

    widgetData.price = thn.dataLayerHelper.get('transactionTotal')
      || thn.dataLayerHelper.get('ecommerce.value') || thn.parseNumber(mhsCV?.revenue)
      || thn.parseNumber(document.querySelector('input#rsk_totalPrice')?.value)
      || thn.parseNumber(thn.objectGet(dataLayer, 'amount'));

    return widgetData;
  };

  /**
     * @memberOf module:bs_15
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const promocode = (document.querySelector('.promocode_input') || {}).value;

    if (promocode) {
      ctx.promocode = promocode;
    }

    return ctx.promocode;
  };

  return engine;

}

export { factory };
